import React, { useState, useEffect } from 'react';
import { Constants } from '../../Constants';
import authService from '../api-authorization/AuthorizeService'
import { VehicleInfoInputCard } from '../VehicleInfoInputCard';
import { ContainerInfoInputCard } from '../ContainerInfoInputCard';
import { OriginLocationCard } from './OriginDetailsCard';
import { DestinationLocationCard } from './DestinationDetailsCard';
import { PricingTable } from './PricingTable';
import { OrderIdTypeChoice } from '../OrderID/OrderIdTypeChoice';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// RJM 10/14/2020: POST handled by Controllers\CreatePosting.cs
// Component for the form that is responsible for collecting user input to create a new vehicle posting
// Do not rename name={values}s, they are bound to the corresponding backend variable
const CreatePosting = () => {
	// Use Effect seems to run BEFORE the constants import, so Constants.postingFormName is null 
	// in UseEffect. But this works for some reason
	const postingFormName = Constants.postingFormName;

	const [EditMode, updateEditMode] = useState(false);
	const [addressesExpanded, updateAddressesExpanded] = useState({"origin" : false, "destination" : false});
	const [submitAction, updateSubmitAction] = useState("/CreatePosting");
	const [postingType, updatePostingType] = useState(Constants.postingType.normal.value);
	const [freightType, updateFreightType] = useState(null); // Constants.freightType.vehicle, Constants.freightType.container
	const [pickupLocationType, updatePickupLocationType] = useState(null); 
	const [dropOffLocationType, updateDropOffLocationType] = useState(null); 
	const [vehicleInputDetails, updateVehicleInputDetails] = useState([JSON.parse(JSON.stringify(Constants.defaultVehicleInputData))]);
	const [containerInputDetails, updateContainerInputDetails] = useState([JSON.parse(JSON.stringify(Constants.defaultContainerInputData))]);
	const [containerSize, updateContainerSize] = useState(Constants.ContainerSize.TwentyFoot.value);
	const [formSubmitting, updateFormSubmitting] = useState(false);
	const [pricesCheckRequested, updatePriceCheckRequested] = useState(false);
	const [loadingAddress, updateLoadingAddress] = useState(JSON.parse(JSON.stringify(Constants.defaultLoadingAddressData)));
	const [deliveryAddress, updateDeliveryAddress] = useState(JSON.parse(JSON.stringify(Constants.defaultDeliveryAddressData)));
	const [priceCheckCompleted, updatePriceCheckCompleted] = useState(true);
	const [apiKey, updateApiKey] = useState("");
	const [shipperContactNumber, updateShipperContactNumber] = useState("");
	const [cookieLoaded, updateCookieLoaded] = useState(false);
	const [currentOrderId, updateCurrentOrderId] = useState("");
	const [priceEntered, updatePriceEntered] = useState(null);
	const [serviceFeePerVehicle, updateServiceFeePerVehicle] = useState(null);
	const [serviceFeePerContainerForShippers, updateServiceFeePerContainerForShippers] = useState(null);
	const [serviceFeePerContainerForCarriers, updateServiceFeePerContainerForCarriers] = useState(null);
	const [creditCardFeeMultiplier, updateCreditCardFeeMultiplier] = useState(null);
	const expDate = new Date()
	expDate.setDate(expDate.getDate() + 7);
	const [expiry, updateExpiry] = useState(expDate)
	useEffect(() => {
		// Parse url
		const urlParams = new URLSearchParams(window.location.search);
		var EditModeFromUrl = urlParams.get('Edit');

		if(EditModeFromUrl == "true"){
			updateEditMode(true);			
			updateSubmitAction("/EditPosting/Post?freightType="+ urlParams.get('freightType') 
								+ "&postingID="+ urlParams.get('ID'))
		}
		
		if(EditModeFromUrl == "true"){
			var postingID = urlParams.get('ID');

			updateFreightType(urlParams.get('freightType'));
			var freightType = urlParams.get('freightType');

			fetch("/EditPosting/GetFreightPosting?freightType="+ urlParams.get('freightType')
					+ "&postingID="+ urlParams.get('ID'))
					.then(response => response.json())
					.then(data => scaffoldOutFormUsingData(data, postingID, freightType));
		}
		else{

			fetch("/ContactNumber")
				.then(response => response.text())
				.then(data => updateShipperContactNumber(data))

			var cookie = getCookie(postingFormName);
			
			if(cookie.length > 10 && !EditMode){
				var cookieData = JSON.parse(cookie);
				// alert(retval.length);
				// You will want to trigger updates here as needed
				var atLeastOneChoice = false;
				for(var key in cookieData) {
					if(key == "freightTypeChoice")
					{
						updateFreightType(cookieData[key]);
						atLeastOneChoice = true;
					}
					if(key == "freightPostingInputModel.pickupLocationType"){
						updatePickupLocationType(cookieData["freightPostingInputModel.pickupLocationType"]);
						atLeastOneChoice = true;
					}
					if(key == "freightPostingInputModel.deliveryLocationType"){
						updateDropOffLocationType(cookieData["freightPostingInputModel.deliveryLocationType"]);
						atLeastOneChoice = true;
					}
					if(key == "vehicleInputDetails"){
						updateVehicleInputDetails(cookieData[key]);
						atLeastOneChoice = true;
					}
					if(key == "containerInputDetails"){
						updateVehicleInputDetails(cookieData[key]);
						atLeastOneChoice = true;
					}
				}
				updateCookieLoaded(atLeastOneChoice);
			}
		}
		
		// Always do this:
		fetch("/MapsApi")
			.then(response => response.text())
			.then(data => updateApiKey(data))

		// fetch("/ServiceFee/GetVehicleServiceFee")
		// 	.then(response => response.text())
		// 	.then(data => updateServiceFeePerVehicle(Number(data)))

		// fetch("/ServiceFee/GetContainerServiceFeeForShipper")
		// 	.then(response => response.text())
		// 	.then(data => updateServiceFeePerContainerForShippers(Number(data)))

		// fetch("/ServiceFee/GetContainerServiceFeeForCarrier")
		// 	.then(response => response.text())
		// 	.then(data => updateServiceFeePerContainerForCarriers(Number(data)))
		// Controllers\api\ServiceFeeController.cs > GetServiceFeeItems
		fetch("/ServiceFee/GetServiceFeeItems")
			.then(response => response.json())
			.then(data => {
				updateServiceFeePerVehicle(Number(data.vehicleServiceFee));
				updateServiceFeePerContainerForShippers(Number(data.containerServiceFeeForShippers));
				updateServiceFeePerContainerForCarriers(Number(data.containerServiceFeeForCarriers));
				updateCreditCardFeeMultiplier(Number(data.creditCardFee));
			});
	}, []);

	const scaffoldOutFormUsingData = (data, postingID, freightType) => {
		if('isQuickPostingFlag' in data){
			if (data['isQuickPostingFlag']){
				updatePostingType(Constants.postingType.quickPosting.value);
			}
			else {
				updatePostingType(Constants.postingType.normal.value);
			}
		}

		updatePickupLocationType(data['pickupLocationType'].toString());
		updateDropOffLocationType(data['deliveryLocationType'].toString());
		updateShipperContactNumber(data['listingContactNumber']);
		updateAddressesExpanded({"origin": true, "destination": true});
		updateCurrentOrderId(data['orderID']);
		updatePriceEntered(data['initialPrice']);
		
		if(freightType == Constants.freightType.vehicle){
			fetch('/Vehicle/GetVehiclesForVehiclePosting?postingID=' + postingID)
				.then(response => response.json())
				.then(data => createVehicleDataFromApiResponse(data));
		}else if(freightType == Constants.freightType.container){
			fetch('/Container/GetContainersForContainerPosting?postingID=' + postingID)
				.then(response => response.json())
				.then(data => createContainerDataFromApiResponse(data));
		}
		
		for(var key in data){
			var formElements = document.getElementById(postingFormName).elements;
			if(key in formElements){
				formElements[key].value = data[key];
			}
			var extraKey = "freightPostingInputModel." + key;
			if(extraKey in formElements){
				formElements[extraKey].value = data[key];
			}
		}
	};

	const createVehicleDataFromApiResponse = (vehicleArray) =>
	{
		var vehicleDetails = [];
		// RJM January 11, 2021; Controllers\api\VehicleController.cs > vehiclePostingEditModel
		vehicleArray.map(vehicle => {
			var vehicleInput = JSON.parse(JSON.stringify(Constants.defaultVehicleInputData));
			vehicleInput.VIN = vehicle.vin;
			vehicleInput.Make = vehicle.make;
			vehicleInput.Model = vehicle.model;
			vehicleInput.Year = vehicle.year;
			vehicleInput.serialNumber = vehicle.serialNumber;
			vehicleInput.VehicleType = vehicle.vehicleType.toString();
			vehicleInput.userFreeTextedVehicleType = vehicle.userFreeTextedVehicleType;
			vehicleInput.VINDecodedVehicleType = vehicle.vehicleType.toString();
			vehicleInput.vehicleCondition = vehicle.vehicleCondition.toString();
			vehicleInput.memberNumber = vehicle.memberNumber;
			vehicleInput.lotNumber = vehicle.lotNumber;
			vehicleInput.attributeEditId = vehicle.attributeEditId;
			vehicleInput.vehicleEditId = vehicle.vehicleEditId;
			vehicleDetails.push(vehicleInput);
		});

		updateVehicleInputDetails([...vehicleDetails]);
	}

	const createContainerDataFromApiResponse = (containerArray) =>
	{
		var containerDetails = [];
		var containerSizeValue = null;
		// RJM January 11, 2021; Controllers\api\ContainerController.cs > containerPostingEditModel
		containerArray.map(container => {
			var containerInput = JSON.parse(JSON.stringify(Constants.defaultContainerInputData));
			containerInput.size = container.size;
			containerInput.bookingNumber = container.bookingNumber;
			containerInput.containerEditId = container.containerEditId;
			if(container.size == 0){
				containerSizeValue = Constants.ContainerSize.TwentyFoot.value;
			}
			if(container.size == 1){
				containerSizeValue = Constants.ContainerSize.FortyFoot.value;
			}
			containerDetails.push(containerInput);
		});
		updateContainerSize(containerSizeValue);
		updateContainerInputDetails([...containerDetails]);
	}


	useEffect(() => {
		if(!cookieLoaded || EditMode){
			return;
		}
		var cookie = getCookie(postingFormName);
		if(cookie.length > 10){
			var cookieData = JSON.parse(cookie);
			// alert(retval.length);
			// You will want to trigger updates here as needed
			for(var key in cookieData){
				var formElements = document.getElementById(postingFormName).elements;
				//alert(key+": "+obj[key]);
				if(key in formElements){
					formElements[key].value = cookieData[key];
				}			
			}
			
		}
	}, [cookieLoaded, EditMode]);

	const onUpdateLoadingAddress = (key,value) => {
		updateAddressesExpanded(prevExpanded => {
			prevExpanded.origin = true;
			return {...prevExpanded};
		});
		updateLoadingAddress(prevLoadingAddress => {
			prevLoadingAddress[key] = value;
			return {...prevLoadingAddress};
		});
	}

	const onUpdateDeliveryAddress = (key,value) => {
		updateAddressesExpanded(prevExpanded => {
			prevExpanded.destination = true;
			return {...prevExpanded};
		});
		updateDeliveryAddress(prevDestinationAddress => {
			prevDestinationAddress[key] = value;
			return {...prevDestinationAddress};
		});
	}

	const onUpdateVehicleInput = (id,key,value) => {
        updateVehicleInputDetails(vehicleInputData => {
			vehicleInputData[id][key] = value;
			return [...vehicleInputData];
		});
	}

	const onUpdateMultipleVehicleInputs = (id,keyValuePairs) => {
		updateVehicleInputDetails(vehicleInputData => {
			keyValuePairs["keys"].forEach((key,index) => {
					vehicleInputData[id][key] = keyValuePairs["values"][index];
					// console.log("Index is " + index + " . Value at index is " + keyValuePairs["values"][index]);
				}
			);
			return [...vehicleInputData];
		})
	}

	const onUpdateContainerInput = (id,key,value) => {
        updateContainerInputDetails(containerInputData => {
			containerInputData[id][key] = value;
			return [...containerInputData];
		});
	}
	
	const addVehicle = () =>
	{
		if(vehicleInputDetails.length < Constants.maxNumVehiclesPerPosting)
		{
			var newInput = JSON.parse(JSON.stringify(Constants.defaultVehicleInputData));
			updateVehicleInputDetails(prevValues => {
				// https://reactjs.org/docs/hooks-reference.html#usestate 
				// (search for 'object spread syntax')
				return [...prevValues, newInput]; 
			});
		}
	}

	const addContainer = () =>
	{
		if(containerInputDetails.length < Constants.maximumContainersPerPosting(containerSize))
		{
			var newInput = JSON.parse(JSON.stringify(Constants.defaultContainerInputData));
			updateContainerInputDetails(prevValues => {
				// https://reactjs.org/docs/hooks-reference.html#usestate 
				// (search for 'object spread syntax')
				return [...prevValues, newInput]; 
			});
		}
	}
	
	const removeVehicle = (index) =>
	{
		var numVehicles = vehicleInputDetails.length;
		if(index < numVehicles && index >= 0 && numVehicles > 1)
		{
			updateVehicleInputDetails(prevValues => {
				prevValues.splice(index,1);
				return [...prevValues];
			})
		}
	}

	const removeContainer = (index) =>
	{
		var numVehicles = containerInputDetails.length;
		if(index < numVehicles && index >= 0 && numVehicles > 1)
		{
			updateContainerInputDetails(prevValues => {
				prevValues.splice(index,1);
				return [...prevValues];
			})
		}
	}

	// #region Cookie
	const setCookie = (c_name,value,expireminutes) =>
	{
		var exdate=new Date();
		exdate.setMinutes(exdate.getMinutes()+expireminutes);
		document.cookie=c_name+ "=" +escape(value)+
		((expireminutes==null) ? "" : ";expires="+exdate.toUTCString())+
		";path=/ClientApp/CreatePosting";
	}

	const getCookie = (c_name) =>
	{
		if (document.cookie.length>0)
		{
			var c_start = document.cookie.indexOf(c_name + "=");
			if (c_start!=-1)
			{
				c_start=c_start + c_name.length+1;
				var c_end=document.cookie.indexOf(";",c_start);
				if (c_end==-1) c_end=document.cookie.length;				
				return unescape(document.cookie.substring(c_start,c_end));
			}
		}
		return "";
	}	

	//#region Components5
	const PostingTypeChoice = () => 
		<div className="col-auto m-1">
			<strong>Choose your posting type</strong><br/>
			<div className="form-check form-check-inline ml-1 my-1">
				<label className="form-check-label" htmlFor="Normal-Type-Choice">
					<input type="radio" className="form-check-input"
						id="Normal-Type-Choice" name="postingTypeChoice" value={Constants.postingType.normal.value}
						onClick={(evt) => updatePostingType(evt.target.value)}
						checked={postingType == Constants.postingType.normal.value}/>
						{Constants.postingType.normal.displayValue}
				</label>
			</div>
			<div className="form-check form-check-inline ml-1 mb-1">
				<label className="form-check-label" htmlFor="Quick-Type-Choice">
					<input type="radio" className="form-check-input"
						id="Quick-Type-Choice" name="postingTypeChoice" value={Constants.postingType.quickPosting.value}
						onClick={(evt) => updatePostingType(evt.target.value)}
						checked={postingType == Constants.postingType.quickPosting.value}
						disabled={EditMode && postingType == Constants.postingType.normal.value}/>
						{Constants.postingType.quickPosting.displayValue}
				</label>
			</div>
			{/* <div className="form-check form-check-inline ml-1 mb-1">
				<label className="form-check-label" htmlFor="Dispatch-Type-Choice">
					<input type="radio" className="form-check-input"
						id="Dispatch-Type-Choice" name="postingTypeChoice" value={Constants.postingType.postAndDispatch.value}
						onClick={(evt) => updatePostingType(evt.target.value)}
						checked={postingType == Constants.postingType.postAndDispatch.value}/>
						{Constants.postingType.postAndDispatch.displayValue}
				</label>
			</div> */}
			<br />
			<em className="text-muted">
				{postingType == Constants.postingType.normal.value && Constants.postingType.normal.description}
				{postingType == Constants.postingType.quickPosting.value && Constants.postingType.quickPosting.description}
				{postingType == Constants.postingType.postAndDispatch.value && Constants.postingType.postAndDispatch.description}
			</em>
		</div>

	const FreightTypeChoice = () =>
		<div className="col-12 my-2">
			<strong>Are you shipping vehicles or containers?</strong>
			<div className="form-check my-1">
				<input type="radio" className="form-check-input"
					id="Vehicle-Transport" name="freightTypeChoice" value={Constants.freightType.vehicle}
					onClick={evt => updateFreightType(evt.target.value)}
					checked={freightType == Constants.freightType.vehicle}/>
				<label className="form-check-label" htmlFor="Vehicle-Transport">
					Vehicles
					<i className="ml-1 fa fa-car"></i>
				</label>
			</div>
			<div className="form-check mb-1">
				<input type="radio" className="form-check-input"
					id="Container-Transport" name="freightTypeChoice" value={Constants.freightType.container}
					onClick={evt => updateFreightType(evt.target.value)}
					checked={freightType == Constants.freightType.container}/>
					
				<label className="form-check-label" htmlFor="Container-Transport">
					Containers
					<i className="ml-1 fa fa-cube"></i>
				</label>
			</div>
		</div>
	
	const ContainerSizeChoice = () => 
		<div className="row">
			<div className="col-auto m-1">
				<strong>What is the size of your container(s)?</strong><br/>
				<div className="form-check form-check-inline ml-1 my-1">
					<label className="form-check-label" htmlFor="Twenty-Foot-Choice">
						<input type="radio" className="form-check-input"
							id="Twenty-Foot-Choice" name="containerSize" value={Constants.ContainerSize.TwentyFoot.value}
							onClick={(evt) => updateContainerSize(evt.target.value)}
							checked={containerSize == Constants.ContainerSize.TwentyFoot.value}/>
							{Constants.ContainerSize.TwentyFoot.displayValue}
					</label>
				</div>
				<div className="form-check form-check-inline ml-1 mb-1">
					<label className="form-check-label" htmlFor="Forty-Foot-Choice">
						<input type="radio" className="form-check-input"
							id="Forty-Foot-Choice" name="containerSize" value={Constants.ContainerSize.FortyFoot.value}
							onClick={(evt) => updateContainerSize(evt.target.value)}
							checked={containerSize == Constants.ContainerSize.FortyFoot.value}/>
							{Constants.ContainerSize.FortyFoot.displayValue}
					</label>
				</div>
			</div>
		</div>

	const OriginAndDestinationTypeChoiceCard = () => 
		<div className="col-12">
			<div className="row">
				<PickupLocationTypeChoice />
				<DestinationLocationTypeChoice />
			</div>
		</div>

	const PickupLocationTypeChoice = () =>
		<div className="col-sm-12 col-md-6 mt-3">
			<label className="form-select-label mb-1" htmlFor="Pickup-Location-Type">
				<strong>What type of location are the {Constants.freightType[freightType]}s being picked up from?</strong>
			</label>  
			<select className="form-select"
				id="Pickup-Location-Type" name="freightPostingInputModel.pickupLocationType"
				onChange={evt => updatePickupLocationType(evt.target.value)}
				value={pickupLocationType}>
					<option value="">-Select Origin</option>
					{freightType == Constants.freightType.vehicle
						&& Object.keys(Constants.locationType).map(key => 
						<option key={key} value={key}>{Constants.locationType[key]}</option>
					)}
					{freightType == Constants.freightType.container
						&& 
						<option value={Constants.ContainerTerminal.value}>{Constants.ContainerTerminal.name}</option>}
			</select>
		</div>

	const DestinationLocationTypeChoice = () =>
		<div className="col-sm-12 col-md-6 mt-3">
			<label className="form-select-label mb-1" htmlFor="Dropoff-Location-Type">
				<strong>What type of location are the {Constants.freightType[freightType]}s being delivered to?</strong>
			</label>
			<select className="form-select"
				id="Dropoff-Location-Type" name="freightPostingInputModel.deliveryLocationType"
				onChange={evt => updateDropOffLocationType(evt.target.value)}
				value={dropOffLocationType}>
					<option value="">-Select Destination</option>
					{Object.keys(Constants.locationType).map(key => 
						<option key={key} value={key}>{Constants.locationType[key]}</option>
					)}
			</select>
		</div>

	const SubmitButton = () =>
		<div className="col-12 mb-3">
			<hr/>
			<button type="submit" disabled={formSubmitting}
				className="btn btn-primary btn-lg btn-block">
				{formSubmitting && <span>Please wait...</span>}
				{!formSubmitting && <span>Submit</span>}
			</button>
			<hr />
			{/* {this.state.fileUploadsMayTakeTimeText} */}
			<div className="alert alert-warning">
				<strong>Please note: If you plan to ship your freight overseas, make sure that the carrier has a Dock Receipt for <em>before</em> they arrive at the port</strong> 
			</div>
		</div>
	//#endregion Components

	// Make sure to remove "|| true" before going live
	const freightTypeSelected = () => freightType != null
	const locationTypesSelected = () => (pickupLocationType != null && dropOffLocationType != null);
	const freightAndLocationTypeSelected = () =>
		freightTypeSelected() && (locationTypesSelected() || (postingType === Constants.postingType.quickPosting.value));

	// Fees calcualtion
	const getServiceFeeForVehicles = (numVehicles) => numVehicles * serviceFeePerVehicle
	const getServiceFeeForContainers = (numContainers) => numContainers * serviceFeePerContainerForShippers
	const getCreditCardFee = (originalPaymentAmount) => originalPaymentAmount * (creditCardFeeMultiplier - 1)
	const getTotalPrice = (originalPaymentAmount) => originalPaymentAmount * creditCardFeeMultiplier

	return (
		<div className="row mt-2">
			<div className="col-12 text-center">
				{!EditMode && <h1 className="h1">New Freight Posting</h1>}
				{EditMode && <h1 className="h1">Edit {freightType} Posting</h1>}
			</div>
			<form id={postingFormName} method="post" action={submitAction} encType="multipart/form-data" 
				onSubmit={() => {
					updateFormSubmitting(true);
					var form = document.getElementById(postingFormName);
  					var json = {};
					for (var i=0;i<form.length;i++) {
						// Make sure they're valid to be stored (i.e. checked, not a button)
						if (form.elements[i].name && (form.elements[i].checked
						  || /select|textarea/i.test(form.elements[i].nodeName)
						  || /text|password/i.test(form.elements[i].type))) {
						  // Store them in an object association
						  json[form.elements[i].name] = form.elements[i].value;
						  //alert(form.elements[i].id+": "+form.elements[i].value);
						}
						json["vehicleInputDetails"] = vehicleInputDetails;
						json["containerInputDetails"] = containerInputDetails;
					  }
					  var stringifiedJSON = JSON.stringify(json);
					  setCookie(postingFormName, stringifiedJSON, 60 * 24 * 3);
				}}>
				{/* Header post and save buttons */}
				{/* <div className="col-12 mb-2">
					<div className="row">
						<div className="col-auto mx-auto">
							<div className="form-group mt-1">
								<input type="submit" value="Post" formAction="/CreatePosting" className="btn btn-primary" />
								<input type="submit" asp-page-handler="SavePosting" className="btn btn-primary" value="Save"
								formnovalidate="formnovalidate"/>
							</div>
						</div>
					</div>
				</div> */}
				<PostingTypeChoice />
				{!EditMode && <FreightTypeChoice />}
				{freightTypeSelected() 
					&& postingType != Constants.postingType.quickPosting.value
					&& <OriginAndDestinationTypeChoiceCard />}
				
				{/* VEHICLE INPUT CARD */}
				{freightAndLocationTypeSelected()
					&& freightType == Constants.freightType.vehicle 
					&& 
					<div className="col-12 mt-2">
						<div className="row">
							<div className="col-12">
								<div className="card p-2 border border-muted">
									<div className="display-5 mb-2">Vehicle information</div>
									{!EditMode &&
										<div className="row">
											<div className="col-auto m-1">
												<strong>Total vehicle(s): {vehicleInputDetails.length}</strong><br />
												<button type="button" className="btn btn-success" onClick={() => addVehicle()}>
													Add Vehicle
												</button>
											</div>
										</div>
									}
									<div className="row justify-content-center">
										{vehicleInputDetails.map((values,index) => 
											<VehicleInfoInputCard key={index} id={index} values={values}
												onUpdate={onUpdateVehicleInput} onRemove={removeVehicle}
												onUpdateMultiple={onUpdateMultipleVehicleInputs}
												baseInputName="vehicleInputList" // Controllers\CreatePosting.cs > vehicleInputList
												auctionDetailsNeeded={pickupLocationType == Constants.locationType["1"]}
												editMode={EditMode}
										/>)}
									</div>
								</div>
							</div>
						</div>
					</div>
				}
				{/* CONTAINER INPUT CARD */}
				{freightAndLocationTypeSelected()
					&& freightType == Constants.freightType.container 
					&& 
					<div className="col-12 mt-2">
						<div className="row">
							<div className="col-12">
								<div className="card p-2 border border-muted">
								<div className="display-5 mb-2">Container information</div>
									<div className="row">
										<div className="col-auto m-1">
											<ContainerSizeChoice />
											<strong>Total container(s): {containerInputDetails.length}</strong><br />
											{/*If Container size is 20 ft, show add container button*/}
											{
												<button type="button" className="btn btn-success" onClick={() => addContainer()}>
													Add Container
												</button>
											}
										</div>
									</div>
									{/* TODO: Add container specific front end */}
									<div className="row justify-content-center">
										{/* Seems like we need to mirror the vehicle info input card because otherwise the
										 	centering of the container card doesn't work like the vehicle one does*/}
										{containerInputDetails.map((values,index) => 
											<ContainerInfoInputCard key={index} id={index} values={values}
												onUpdate={onUpdateContainerInput} onRemove={removeContainer}
												baseInputName="containerInputList" // Controllers\CreatePosting.cs > containerInputList
												containerSize={containerSize}
												editMode={EditMode}
										/>)}
									</div>
								</div>
							</div>
						</div>
					</div>
				}
				{/* ORIGIN AND DESTINATION LOCATION INPUT CARDs */}
				{freightAndLocationTypeSelected() 
					&&
					<div className="col-12">
						<div className="row">
							<OriginLocationCard 
								postingType={postingType} 
								values={loadingAddress} 
								onUpdateLoadingAddress={onUpdateLoadingAddress} 
								bingApiKey={apiKey}
								expandAddress={addressesExpanded.origin}/>
							<DestinationLocationCard 
								postingType={postingType} 
								values={deliveryAddress} 
								onUpdateDeliveryAddress={onUpdateDeliveryAddress} 
								bingApiKey={apiKey}
								expandAddress={addressesExpanded.destination}/>
						</div>
						<hr />
						<div className="card p-2 border border-muted">
							<div className="form-group col-sm-12 col-md-6" style={{"zIndex":"10"}}>
							<label className="control-label">Posting expiry</label><br />
								<DatePicker showTimeSelect name="freightPostingInputModel.postingExpiry"
									selected={expiry}
									onChange={(value) => updateExpiry(value)}
									dateFormat="MM/dd/yyyy h:mm aa"
									/>
							</div>
						</div>
					</div>
				}
				{/* Flag to Assign to carrier Right away, and add carrier selection card */}
				
				{/* CONTACT NUMBER AND ORDER ID */}
				{freightAndLocationTypeSelected()
					&& addressesExpanded.origin 
					&& addressesExpanded.destination 
					&&
					<div className="col-sm-12 col-md-6 my-1">
						<div className="row">
							<div className="col-12 pt-1">
								<div className="form-group">
									<label  className="control-label">Contact number for this posting</label>
									<input required type="text" name="freightPostingInputModel.listingContactNumber" 
										value={shipperContactNumber} className="form-control" onChange={(evt) => updateShipperContactNumber(evt.target.value)}/>
								</div>
							</div>
							{/* Order ID generation */}
							<OrderIdTypeChoice freightType={freightType} dontAutoGenerateOnLoad={EditMode} currentOrderId={currentOrderId} onChangeId={updateCurrentOrderId}/>
						</div>
					</div>
				
				}

				{/* PRICE INPUT AND PRICE CHECK */}
				{freightAndLocationTypeSelected()
					&& addressesExpanded.origin 
					&& addressesExpanded.destination 
					&&
					<div className="col-sm-12 col-md-6 my-1">
						<div className="row">
							<div className="col-12 pt-1">
								<div className="form-group">
									<label className="control-label">Price</label>
									<div className="input-group">
										<div className="input-group-prepend">
											<div className="input-group-text">$</div>
										</div>
										<input name="freightPostingInputModel.initialPrice" required 
											type="number" step=".01" min={0} className="form-control"
											onChange={evt => {
												if(evt.target.value == 0 || evt.target.value == "0"){
													updatePriceEntered("");
												}else{
													updatePriceEntered(Number(evt.target.value));
												}
											}}
											value={priceEntered} />
										<div className="input-group-append">
											<input type="button" className="btn btn-success my-auto" value="Check prices" 
											onClick={() =>{ 
												updatePriceCheckRequested(true);
												updatePriceCheckCompleted(false);
											}} />											
										</div>
									</div>
								</div>
							</div>
							<div className="col-12 pt-1">
								{pricesCheckRequested 
								&& 
									<PricingTable 
										type={freightType}
										loadingZipCode={loadingAddress["freightPostingInputModel.loadingPostalcode"]}
										loadingCityName={loadingAddress["freightPostingInputModel.loadingCity"]}
										loadingStateName={loadingAddress["freightPostingInputModel.loadingState"]}
										
										deliveryZipCode={deliveryAddress["freightPostingInputModel.deliveryPostalcode"]}
										deliveryCityName={deliveryAddress["freightPostingInputModel.deliveryCity"]}
										deliveryStateName={deliveryAddress["freightPostingInputModel.deliveryState"]}
										setPriceCheckComplete={updatePriceCheckCompleted}
										priceCheckCompleted={priceCheckCompleted}
								/>}
							</div>
						</div>
					</div>
				}
				{freightAndLocationTypeSelected() 
					&& addressesExpanded.origin 
					&& addressesExpanded.destination 
					&& 
					<>
						<div className="col-12">
							<h4>Price breakdown</h4>
							<div className="row">
								<div className="col-sm-12 col-md-6 mb-sm-2 mb-md-none">
									<div className="card p-2 grad-bg-purp-rep border border-dark">
										{/* This could use a refactor sometime */}
										<span><strong>Your listed price: </strong>${priceEntered}</span>
										{freightType == Constants.freightType.vehicle
											&& <>
											<span><strong>Service fee: </strong> {vehicleInputDetails.length} vehicles x ${serviceFeePerVehicle} = ${getServiceFeeForVehicles(vehicleInputDetails.length).toFixed(2)}</span>
											<span><strong>Credit card fee: </strong> $ {getCreditCardFee(priceEntered + getServiceFeeForVehicles(vehicleInputDetails.length)).toFixed(3)} ({(creditCardFeeMultiplier - 1).toFixed(4)*100}%)</span>
											<strong>Your total payment: </strong>
											<div className="display-5">
												${getTotalPrice(priceEntered + getServiceFeeForVehicles(vehicleInputDetails.length)).toFixed(2)}
											</div>
										</>}
										{freightType == Constants.freightType.container
											&& <>
											<span><strong>Service fee: </strong> {containerInputDetails.length} containers x ${serviceFeePerContainerForShippers} = ${getServiceFeeForContainers(containerInputDetails.length).toFixed(2)}</span>
											<span><strong>Credit card fee: </strong> $ {getCreditCardFee(priceEntered + getServiceFeeForContainers(containerInputDetails.length)).toFixed(3)} ({(creditCardFeeMultiplier - 1).toFixed(4)*100}%)</span>
											<strong>Your total payment: </strong>
											<div className="display-5">
												${getTotalPrice(priceEntered + getServiceFeeForContainers(containerInputDetails.length)).toFixed(2)}
											</div>
										</>}											
									</div>
								</div>
								
								<div className="col-sm-12 col-md-6">
									<div className="card p-2 border border-dark">
										<strong>Payment to carrier: </strong>
										<div className="display-5">
											${priceEntered}
										</div>
										<em className="text-muted">Carrier's final payment may differ based on their service fee</em>
									</div>
								</div>
								<div className="col-12">
									<em>Note: Payment will be debited when carrier marks freight as picked up</em>
								</div>
							</div>
						</div>
					</>
				}
				{/* Additional terms */}
				{freightAndLocationTypeSelected() 
					&& postingType != Constants.postingType.quickPosting.value
					&& addressesExpanded.origin 
					&& addressesExpanded.destination 
					&&
					<div className="col-12 mt-2">
						<label className="form-label" htmlFor="Additional-Terms">Additional Terms</label>
						<textarea id="Additional-Terms" name="freightPostingInputModel.additionalTerms" className="form-control" rows="3"></textarea>
					</div>					
				}
				{freightAndLocationTypeSelected() 
					&& addressesExpanded.origin 
					&& addressesExpanded.destination 
					&& 
					<SubmitButton />
				}
			</form>
			<div className="col-12" style={{"minHeight":"25vh"}}></div> 
		</div>  
  	);
}

export { CreatePosting };